import { LENDER_SOURCES, type YbrCategory } from "./lender-sources";

/**
 * Accredited residential panel. Never surface the aggregator name on the UI.
 * loans.com.au, Athena, Unloan, BCU, HSBC and 86400 are not on this list.
 */
export type { YbrCategory };

export type YbrLender = {
  id: string;
  name: string;
  aliases: string[];
  category: YbrCategory;
  website: string;
  ratesUrl: string;
};

const BLOCKED = [
  "loans com au",
  "loans.com.au",
  "athena",
  "unloan",
  "pacific mortgage",
  "hsbc",
  "86400",
  "bcu",
  "greater bank",
  "virgin money",
  "people first",
  "heritage bank",
  "yellow brick road",
];

export const YBR_PANEL: YbrLender[] = LENDER_SOURCES.map((row) => ({
  id: row.id,
  name: row.name,
  aliases: row.aliases,
  category: row.category,
  website: row.website,
  ratesUrl: row.ratesUrl,
}));

export function panelKey(name: string): string {
  return ` ${name.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim()} `;
}

function aliasNeedle(alias: string): string | null {
  const needle = panelKey(alias);
  if (needle.trim().length < 3) return null;
  return needle;
}

export function matchYbrLender(lender: string): YbrLender | null {
  const hay = panelKey(lender);
  if (BLOCKED.some((b) => hay.includes(panelKey(b)))) return null;
  let best: { row: YbrLender; len: number } | null = null;
  for (const row of YBR_PANEL) {
    for (const alias of [row.name, ...row.aliases]) {
      const needle = aliasNeedle(alias);
      if (!needle || !hay.includes(needle)) continue;
      const len = needle.trim().length;
      if (!best || len > best.len) best = { row, len };
    }
  }
  return best?.row ?? null;
}
